import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";

import Switch from "material-ui/Switch";
import Radio from "material-ui/Radio";
import List, {
  ListItem,
  ListItemText,
  ListItemSecondaryAction
} from "material-ui/List";
import ModalFormDialog from "./ModalFormDialog";
import Typography from "material-ui/Typography";
import { roleName, displayName, capitalize } from "./helpers/presentation";

const styles = theme => ({
  switchGroup: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  listItem: {
    minHeight: 60
  },
  rightLabel: {
    width: 120
  },
  superuser: {
    color: theme.palette.secondary["700"]
  }
});

const Invoice = props => {
  const { user, open, onSave, onChange, onCancel, classes } = props;

  const handleStatusChange = (event, checked) => {
    onChange({ active: checked });
  };

  const handleRoleChange = event => {
    onChange({ role: parseInt(event.currentTarget.value, 10) });
  };

  const renderRoleRadios = () => {
    const roles = [1, 2, 3];
    if (user.accountName === "conductor") {
      roles.unshift(0);
    }

    return roles.map(r => {
      return (
        <Radio
          key={r}
          checked={user.role === r}
          className={r === 0 ? classes.superuser : ""}
          onChange={handleRoleChange}
          value={`${r}`}
        />
      );
    });
  };

  const renderDisplayNameAndAccount = () => {
    return `${displayName(user)} - ${capitalize(
      user.accountName || "No account"
    )}`;
  };

  return (
    <div>
      <ModalFormDialog
        title="Edit user"
        open={open}
        onCancel={onCancel}
        onSave={onSave}
      >
        <List>
          <ListItem divider>
            <ListItemText primary={renderDisplayNameAndAccount()} />
          </ListItem>

          <ListItem divider>
            <ListItemText primary="Email" secondary={user.email} />
          </ListItem>
          <ListItem divider className={classes.listItem}>
            <ListItemText primary="Status" />
            <ListItemSecondaryAction>
              <div className={classes.switchGroup}>
                <Switch checked={user.active} onChange={handleStatusChange} />
                <Typography
                  type="body1"
                  align="right"
                  className={classes.rightLabel}
                >
                  {user.active ? "Active" : "Inactive"}
                </Typography>
              </div>
            </ListItemSecondaryAction>
          </ListItem>

          <ListItem divider className={classes.listItem}>
            <ListItemText primary="Role" />
            <ListItemSecondaryAction>
              <div className={classes.switchGroup}>
                {renderRoleRadios(classes)}

                <Typography
                  type="body1"
                  align="right"
                  className={classes.rightLabel}
                >
                  {roleName(props.user.role)}
                </Typography>
              </div>
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      </ModalFormDialog>
    </div>
  );
};

Invoice.propTypes = {
  user: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export { Invoice };

export default withStyles(styles, { name: "Invoice" })(Invoice);



// WEBPACK FOOTER //
// ./src/EditUserDialog.js